import isEqual from 'react-fast-compare';
import { RoleType } from '@tribeplatform/gql-client/types';
import { useQuery, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getAuthMemberKey } from '../../utils/keys';
export const useAuthMember = (options) => {
    var _a, _b, _c, _d, _e;
    const queryClient = useQueryClient();
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const authMemberKey = getAuthMemberKey();
    const authTokenKey = getAuthTokensKey();
    const query = useQuery(authMemberKey, () => client.auth.authMember(fields), {
        isDataEqual: isEqual,
        initialData: () => {
            var _a;
            return (_a = queryClient.getQueryData(authTokenKey)) === null || _a === void 0 ? void 0 : _a.member;
        },
        ...useQueryOptions,
    });
    const member = query === null || query === void 0 ? void 0 : query.data;
    const isAdmin = ((_a = member === null || member === void 0 ? void 0 : member.role) === null || _a === void 0 ? void 0 : _a.type) === RoleType.ADMIN;
    const isModerator = ((_b = member === null || member === void 0 ? void 0 : member.role) === null || _b === void 0 ? void 0 : _b.type) === RoleType.MODERATOR ||
        ((_c = member === null || member === void 0 ? void 0 : member.role) === null || _c === void 0 ? void 0 : _c.type) === RoleType.ADMIN;
    const isGuest = !member || !((_d = member === null || member === void 0 ? void 0 : member.role) === null || _d === void 0 ? void 0 : _d.type) || ((_e = member === null || member === void 0 ? void 0 : member.role) === null || _e === void 0 ? void 0 : _e.type) === RoleType.GUEST;
    return {
        isAdmin,
        isGuest,
        isModerator,
        ...query,
    };
};
//# sourceMappingURL=useAuthMember.js.map